import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AlertError14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_13)'>
      <path
        d='M8.06061 7L9.53027 8.46967L8.46961 9.53033L6.99995 8.06066L5.53027 9.53033L4.46961 8.46967L5.93929 7L4.46961 5.53033L5.53027 4.46967L6.99995 5.93934L8.46961 4.46967L9.53027 5.53033L8.06061 7Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 6.99994C0.25 3.27202 3.27208 0.249939 7 0.249939C10.7279 0.249939 13.75 3.27202 13.75 6.99994C13.75 10.7279 10.7279 13.7499 7 13.7499C3.27208 13.7499 0.25 10.7279 0.25 6.99994ZM7 1.74994C4.1005 1.74994 1.75 4.10044 1.75 6.99994C1.75 9.89943 4.1005 12.2499 7 12.2499C9.8995 12.2499 12.25 9.89943 12.25 6.99994C12.25 4.10044 9.8995 1.74994 7 1.74994Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_13'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

AlertError14.displayName = 'AlertError14';
export default AlertError14;
